import cookies from './BaseCookies';

const CreateCookie = (token) => {
    cookies.set('token',token,{path:'/'});
}

export default CreateCookie;